<style>
  .card-header-formatting {
    padding-top: 16px;
    padding-bottom: 16px;
    background: linear-gradient(112.2deg, var(--sl-color-primary-400) 14.86%, var(--sl-color-primary-700) 102.08%);
    color: white;
  }

  .card-header-formatting a:visited {
    color: #f7be6a;
  }

  .error {
    color: #ff4444;
  }

  fadv-button::part(interior) {
    display: inline-block;
  }

  fadv-grid-col {
    padding: 0 var(--sl-spacing-small);
  }

  fadv-grid-col:first-child {
    padding-left: 1;
  }

  fadv-grid-col:last-child {
    padding-right: 1;
  }
</style>
<fadv-card>
  <fadv-card-header>
    <div class="card-header-formatting">
      <fadv-typography style="text-align: center" type="heading-small" variant="white">
        Get Started With First Advantage
      </fadv-typography>
      <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
    </div>
  </fadv-card-header>

  <fadv-card-body>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <fadv-grid>
        <fadv-grid-row>
          <fadv-grid-col>
            <fadv-box pl="x-small" pt="large" pb="small">
              <fadv-typography type="label-medium">
                <strong>Personal Information</strong>
              </fadv-typography>
            </fadv-box>
          </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
          <fadv-grid-col [col]="{ xs: 12, sm: 12, md: 12, l: 12, xl: 6 }">
            <fadv-input (blur)="form.get('firstName').markAsDirty(); this.showValidation('firstName');" autocapitalize="false" autocomplete="false"
              autofocus="autofocus" autocorrect="false" clearable="" helpText="" inputmode="name" id="firstName"
              label="First Name*" max="250" maxLength="250" min="1" minLength="0" name="firstName" type="text" value=""
              variant="primary" formControlName="firstName"
              [invalid]="form.get('firstName')?.invalid && form.get('firstName')?.dirty"></fadv-input>
            <fadv-box pl="x-small">
              <span class="error" *ngIf="this.firstNameInvalid == true">
                <small *ngIf="form.get('firstName').hasError('required')">First Name is Required</small>
                <small *ngIf="form.get('firstName').hasError('pattern')">First Name cannot contain numbers</small>
                <small
                  *ngIf="form.get('firstName').hasError('whitespace') && !form.get('firstName').hasError('required')">First
                  Name cannot be empty</small>
              </span>
            </fadv-box>
          </fadv-grid-col>
          <fadv-grid-col [col]="{ xs: 12, sm: 12, md: 12, l: 12, xl: 6 }">
            <fadv-input (blur)="form.get('lastName').markAsDirty(); this.showValidation('lastName');" autocapitalize="false" autocomplete="false"
              autocorrect="false" clearable="" helpText="" inputmode="text" id="lastName" label="Last Name*" max="250"
              maxLength="250" min="1" minLength="0" name="lastName" type="text" value="" variant="primary"
              formControlName="lastName" [invalid]="form.get('lastName')?.invalid && form.get('lastName')?.dirty">
            </fadv-input>
            <fadv-box pl="x-small">
              <span class="error" *ngIf="this.lastNameInvalid == true">
                <small *ngIf="form.get('lastName').hasError('required')">Last Name is Required</small>
                <small *ngIf="form.get('lastName').hasError('pattern')">Last Name cannot contain numbers</small>
                <small
                  *ngIf="form.get('lastName').hasError('whitespace') && !form.get('lastName').hasError('required')">Last
                  Name cannot be empty</small>
              </span>
            </fadv-box>
          </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
          <fadv-grid-col>
            <fadv-box pl="x-small" pt="medium" pb="small">
              <fadv-typography type="label-medium">
                <strong>Company Information</strong>
              </fadv-typography>
            </fadv-box>
          </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
          <fadv-grid-col [col]="{ xs: 12, sm: 12, md: 12, l: 12, xl: 6 }">
            <fadv-input (blur)="form.get('companyName').markAsDirty(); this.showValidation('companyName');" autocapitalize="false" autocomplete="false"
              autocorrect="false" clearable="" helpText="" inputmode="text" id="companyName" label="Company Name*"
              max="250" maxLength="250" min="1" minLength="0" name="companyName" type="text" value="" variant="primary"
              formControlName="companyName"
              [invalid]="form.get('companyName')?.invalid && form.get('companyName')?.dirty"></fadv-input>
            <fadv-box pl="x-small">
              <span class="error" *ngIf="this.companyNameInvalid == true">
                <small *ngIf="form.get('companyName').hasError('required')">Company Name is Required</small>
                <small
                  *ngIf="form.get('companyName').hasError('whitespace') && !form.get('companyName').hasError('required')">Company
                  Name cannot be empty</small>
              </span>
            </fadv-box>
          </fadv-grid-col>
          <fadv-grid-col [col]="{ xs: 12, sm: 12, md: 12, l: 12, xl: 6 }">
            <fadv-select (blur)="form.get('clientnatureofbusiness').markAsDirty(); this.showValidation('clientnatureofbusiness');"
              (changed)="toggleNatureOfBusiness($event.target.value === 'Other')"
              formControlName="clientnatureofbusiness" hoist="true" scrollable="true"
              label="Company Nature Of Business *">
              <fadv-menu-item *ngFor="let type of natureOfBusiness | keyvalue" value="{{type.value}}">
                {{type.value}}</fadv-menu-item>
            </fadv-select>
            <fadv-box pl="x-small">
              <span class="error"
              *ngIf="form.get('clientnatureofbusiness').invalid && form.get('clientnatureofbusiness').dirty">
                <small>Nature of Business is Required</small>
              </span>
            </fadv-box>
          </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
          <fadv-grid-col>
            <fadv-input *ngIf="getOtherNatureofBusiness" (blur)="form.get('othernatureofbusiness').markAsDirty(); this.showValidation('othernatureofbusiness');"
              inputmode="text" label="Enter Your Company's Nature Of Business *" type="text" value="" variant="primary"
              formControlName="othernatureofbusiness"></fadv-input>
            <fadv-box pl="x-small">
              <span class="error"
                *ngIf="this.othernatureofbusinessInvalid == true">
                <small *ngIf="form.get('othernatureofbusiness').hasError('required')">Nature of Business is
                  Required</small>
                <small
                  *ngIf="form.get('othernatureofbusiness').hasError('whitespace') && !form.get('othernatureofbusiness').hasError('required')">Nature
                  of Business cannot be empty</small>
              </span>
            </fadv-box>
          </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
          <fadv-grid-col [col]="{ xs: 12, sm: 12, md: 12, l: 12, xl: 6 }">
            <fadv-input (blur)="this?.form?.get('phoneNumber').markAsDirty(); this?.showValidation('phoneNumber');"
              [maxlength]="10" type="tel" [minlength]="10" requiredautocapitalize="false" autocomplete="false"
              autocorrect="false" clearable="" inputmode="text" id="phoneNumber" label="Phone Number*" max="250"
              maxLength="250" min="1" minLength="0" name="phoneNumber" value="" variant="primary"
              formControlName="phoneNumber"
              [invalid]="this?.form?.get('phoneNumber')?.invalid && this?.form?.get('phoneNumber')?.dirty"></fadv-input>
            <fadv-box pl="x-small">
              <span class="error" *ngIf="this.phoneNumberInvalid == true">
                <small *ngIf="this?.form?.get('phoneNumber').hasError('required')">Phone Number is Required</small>
                <small
                  *ngIf="this?.form?.get('phoneNumber').hasError('minlength') || this?.form?.get('phoneNumber').hasError('pattern')">Phone
                  Number must be 10 numbers</small>
              </span>
            </fadv-box>
          </fadv-grid-col>
          <fadv-grid-col [col]="{ xs: 12, sm: 12, md: 12, l: 12, xl: 6 }">
            <fadv-input (blur)="this?.form?.get('email').markAsDirty(); this?.showValidation('email');" autocapitalize="false"
              autocomplete="false" autocorrect="false" clearable="" helpText="" inputmode="email" id="email"
              label="Company Email Address*" max="250" maxLength="250" min="1" minLength="0" name="email" type="email"
              value="" variant="primary" formControlName="email"
              [invalid]="this?.form?.get('email')?.invalid && this?.form?.get('email')?.dirty"></fadv-input>
            <fadv-box pl="x-small">
              <span class="error" *ngIf="this.emailInvalid == true">
                <small>Email is Required</small>
              </span>
            </fadv-box>
          </fadv-grid-col>
          <fadv-grid-col [col]="{ xs: 12, sm: 12, md: 12, l: 12, xl: 6 }">
            <fadv-input (blur)="this?.form?.get('billToZip').markAsDirty(); this?.showValidation('billToZip')" [maxlength]="5"
              id="billToZip" name="billToZip" label="Postal Code*" formControlName="billToZip"
              [valid]="this?.form?.get('billToZip')?.valid"
              [invalid]="this?.form?.get('billToZip')?.invalid && this?.form?.get('billToZip')?.dirty"></fadv-input>
            <fadv-box pl="x-small">
              <span class="error" *ngIf="this.billToZipInvalid == true">
                <small *ngIf="this?.form?.get('billToZip').hasError('required')">Zip Code is Required</small>
                <small
                  *ngIf="this?.form?.get('billToZip').hasError('minlength') || this?.form?.get('billToZip').hasError('pattern')">Zip
                  Code must be 5 numbers</small>
              </span>
            </fadv-box>
          </fadv-grid-col>
          <fadv-grid-col [col]="{ xs: 12, sm: 12, md: 12, l: 12, xl: 6 }">
            <fadv-select label="Number Of Employees*"
            hoist="true" scrollable="true"
            formControlName="numberOfEmployees"
            (blur)="this?.form?.get('numberOfEmployees').markAsDirty();">
            <fadv-menu-item value="5000-or-more">5,000 Or More</fadv-menu-item>
            <fadv-menu-item value="2500-4999">2,500-4,999</fadv-menu-item>
            <fadv-menu-item value="1000-2499">1,000-2,499</fadv-menu-item>
            <fadv-menu-item value="500-999">500-999</fadv-menu-item>
            <fadv-menu-item value="100-499">100-499</fadv-menu-item>
            <fadv-menu-item value="under-100">Less than 100</fadv-menu-item>
            </fadv-select>
          </fadv-grid-col>
        </fadv-grid-row>

        <fadv-grid-row>
          <fadv-grid-col alignment="center">
            <fadv-box pt="xxx-large" pb="large">
              <fadv-button style="width:200px;" [loading]="loading" [active]="loading" [disabled]="loading"
                size="medium" variant="primary" [disabled]="this.form.invalid" (click)="onSubmit()" type="button"
                name="see-pricing-button">
                SEE PRICING
              </fadv-button>
            </fadv-box>
          </fadv-grid-col>
        </fadv-grid-row>
      </fadv-grid>
    </form>
  </fadv-card-body>
</fadv-card>